import { useEffect, useRef, useState } from "react";
import { formatImageUrl } from "../../_helpers/format-image-url";
import { UseCarContext } from "../../services/products/product.context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";

import { searchProduct } from "../../_helpers/search";



export const SearchForm = () => {

    const [searchResults, setSearchResults] = useState();
    const [searchInput, setSearchInput] = useState();

    const { showSearch, closeSearch, someCars, focusInput } = UseCarContext();

    const navigateTo = useNavigate();

    const searchCars = (input) => {
        const resp = searchProduct(input, someCars);
        setSearchResults(resp);
    }

    const searchInputRef = useRef();

    useEffect(() => {
        if (showSearch) searchInputRef.current.focus();
    }, [showSearch])

    return (
        <div className={classNames("search-form-container", { 'view': showSearch })}>
            <div className="close-box">
                <button className="tr-btn close-src"
                    onClick={() => {
                        closeSearch();
                        setSearchResults();
                        setSearchInput()
                    }}
                >
                    <FontAwesomeIcon icon={faClose} />
                </button>
            </div>
            <div className="search-input-conatiner">
                <input
                    type="search"
                    className="search-input"
                    onChange={(e) => {
                        searchCars(e.target.value);
                        setSearchInput(e.target.value);
                    }}
                    ref={searchInputRef}
                    placeholder="Search for..."
                />
            </div>
            {searchResults &&
                (
                    (searchResults.length > 0 && searchInput) ?
                        (<div className="search-result-conatiner">
                            {searchResults?.map((result) => {
                                return (
                                    <button
                                        className="result-unit"
                                        onClick={() => {
                                            navigateTo(
                                                "/details", { state: { car: result } }
                                            );
                                            closeSearch();
                                        }}
                                    >
                                        <img
                                            src={formatImageUrl(result?.images[0])}
                                            alt=""
                                            className="result-pic"
                                        />
                                        <span className="result-text">
                                            {result?.brand + " " + result?.model + " " + result?.year}
                                        </span>
                                    </button>
                                )
                            })}
                        </div>) :
                        (
                            <div className="no-results">
                                No search results{' for ' + searchInput + " ."}
                            </div>
                        )
                )
            }
        </div>
    )
}